export const LocalizationAgGrid = {
    page: 'Página',
    more: 'Mais',
    to: '-',
    of: 'de',
    next: 'Próximo',
    last: 'Último',
    first: 'Primeiro',
    previous: 'Anterior',
    loadingOoo: 'Carregando...',
    pageSizeSelectorLabel: 'Resultados por página',
    // for set filter
    selectAll: 'Selecionar Tudo',
    searchOoo: 'Buscar...',
    blanks: 'Vazios',
    // for number filter and text filter
    filterOoo: 'Filtrar...',
    applyFilter: 'Aplicar Filtro...',
    // for number filter
    equals: 'Igual a',
    notEqual: 'Diferente de',
    lessThan: 'Menor que',
    greaterThan: 'Maior que',
    // for text filter
    contains: 'Contém',
    notContains: 'Não Contém',
    startsWith: 'Começa Com',
    endsWith: 'Termina Com',
    // the header of the default group column
    group: 'Grupo',
    // tool panel
    columns: 'Colunas',
    // other
    noRowsToShow: 'Sem dados para exibir',
    // enterprise menu
    pinColumn: 'Fixar Coluna',
    valueAggregation: 'Agregação de Valor',
    autosizeThiscolumn: 'Tamanho automático nesta coluna',
    autosizeAllColumns: 'Tamanho automático em todas as colunas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    resetColumns: 'Resetar Colunas',
    expandAll: 'Expandir Todos',
    collapseAll: 'Recolher Todos',
    toolPanel: 'Painel de Ferramentas',
    export: 'Exportar',
    csvExport: 'Exportar para CSV',
    excelExport: 'Exportar para Excel',
    pdfExport: 'Exportar para PDF',
    excelXmlExport: 'Exportar para Excel (.xml)',
    // enterprise menu pinning
    pinLeft: 'Fixar à esquerda',
    pinRight: 'Fixar à direita',
    // enterprise menu aggregation and status panel
    sum: 'Somar',
    min: 'Mínimo',
    max: 'Máximo',
    none: 'Nenhum',
    count: 'Contagem',
    average: 'Média',
    // standard menu
    copy: 'Copiar',
    copyWithHeaders: 'Copiar com cabeçalhos',
    ctrlC: 'ctrl + C',
    paste: 'Colar',
    ctrlV: 'ctrl + V'
};